<template>
  <div id="app" v-if="!isMobile">
    <HearTop></HearTop>
    <router-view/>
    <Footer></Footer>
  </div>
  <div id="app" v-else>
    <router-view/>
  </div>
</template>
<script>
import HearTop from './hearTop'
import Footer from './footer'
export default {
  data () {
    return {
      isMobile: false
    }
  },
  components:{
    HearTop,
    Footer,
  },
  mounted() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
      this.isMobile = true
      console.log('iPhone');
    } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
      this.isMobile = true
      console.log('Android');
    } else { //pc
      this.isMobile = false
      console.log('pc');
    };
  }
}
</script>


// WEBPACK FOOTER //
// src/components/navTop/index.vue